import { mapGetters, mapMutations } from "vuex";
import { directive as onClickaway } from "vue-clickaway";
import { camelCase } from "lodash";

import headerSearch from "../header-search/index.vue";

export default {
    name: "mobile-navigation",
    directives: {
        onClickaway: onClickaway,
    },
    data() {
        return {
            label: "",
            isShowCoursesHeaderNav: false,
        };
    },
    components: {
        headerSearch,
    },
    watch: {
        $route() {
            this.isShowCoursesHeaderNav = false;
        },
    },
    computed: {
        ...mapGetters({
            openMobileMenu: "system/openMenu",
            activeStep: "actionPlans/activeStep",
            currentItem: "actionPlans/currentItem",
            currentCoursesItem: "courses/currentItem",
            courseNavigation: "courses/components",
        }),
        // for action plans
        progressPercent() {
            return Math.round(((this.activeStep + 1) / this.listLength) * 100);
        },
        listLength() {
            return this.currentItem.contents.data.length;
        },
        isActionPlan() {
            return this.$route.path.includes("/action-plans/");
        },
        // end action plans
        labelRoute() {
            return this.$t(camelCase(this.$route.name));
        },
        showArrowBack() {
            if (this.$route.hasOwnProperty("meta")) {
                return !this.$route.meta.isChildrenRoute;
            }
            return false;
        },
        isCourseRoute() {
            return this.$route.fullPath.includes("/courses/");
        },
        courseNavigationItems() {
            return Object.values(this.courseNavigation);
        },
    },
    methods: {
        ...mapMutations({
            changeMobileMenu: "system/CHANGE_MOBILE_MENU",
            changeSearch: "system/CHANGE_OPEN_SEARCH",
        }),
        changeAction(val) {
            if (val) {
                if (this.$route.path.includes("/lesson")) {
                    this.$router.push({
                        name: "courses-main",
                        params: { item: this.currentCoursesItem.slug },
                        query: { active: "true" },
                    });
                } else {
                    if (this.$route.name === "courses-dashboard") {
                        this.$router.push({ name: "courses" });
                    } else {
                        this.$router.go(-1);
                    }
                }
            } else {
                this.changeMobileMenu(!this.openMobileMenu);
            }
        },
        changeShowHeaderCoursesNav() {
            if (this.isCourseRoute) {
                this.isShowCoursesHeaderNav = !this.isShowCoursesHeaderNav;
            }
        },
        closeShowHeaderCoursesNav() {
            if (this.isCourseRoute) {
                this.isShowCoursesHeaderNav = false;
            }
        },
        openHeaderSearch() {
            this.changeSearch(true);
        },
    },
};
